import CreationToolFont from '../../../../types/font'
import CreationToolFontSize from '../../../../types/font-size'
import { generateCaptionCanvas } from '../../../artboard/utils'
import { ICapture, ISegment, IWatermark } from '../types'

const getSegmentCaptionWatermark = async (segment: ISegment, capture: ICapture): Promise<IWatermark> => {
    // segment already has watermark
    if (segment.editParams?.watermark) {
        return segment.editParams?.watermark
    }

    if (capture.custom_font?.filename) {
        const fontFace = new FontFace(
            `uploadedFont-${capture.custom_font.filename}`,
            `url(${capture.custom_font.fontUrl})`
        )
        // @ts-ignore
        document.fonts.add(fontFace)
        await fontFace.load()
    }
    // segment has caption and style data on capture, but no watermark yet
    if (
        segment.caption &&
        capture.upload_metadata?.caption_position &&
        capture.upload_metadata?.caption_style &&
        capture.upload_metadata?.auto_caption
    ) {
        // generate a watermark for segment if caption exists but no watermark exists
        try {
            const position = capture.upload_metadata.caption_position
            const style = capture.upload_metadata.caption_style
            const captionCanvas = await generateCaptionCanvas(
                {
                    text: CreationToolFont.isAllCaps(style.font) ? segment.caption.toUpperCase() : segment.caption,
                    color: style.color,
                    strokeColor: style.strokeColor,
                    fontFamily: capture.custom_font
                        ? `"uploadedFont-${capture.custom_font.filename}"`
                        : CreationToolFont.fontFamily(style.font),
                    fontWeight: CreationToolFont.fontWeight(style.font),
                    fontSize:
                        CreationToolFontSize.sizeBaseOnHeight(style.fontSize) *
                        CreationToolFont.scale(style.font) *
                        capture.height,
                },
                capture.width * 0.9
            )

            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')

            canvas.width = capture.width
            canvas.height = capture.height

            context?.drawImage(
                captionCanvas,
                position.x - captionCanvas.width / 2,
                position.y - captionCanvas.height / 2
            )

            return { id: '', filename: '', imageUrl: canvas.toDataURL('image/png', 0.7) }
        } catch (e) {}
    }

    return { id: '', imageUrl: '', filename: '' }
}

export default getSegmentCaptionWatermark
